webpackJsonp([5],{

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(357)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(386),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2443c47a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDlDMTYuNTUyMyA5IDE3IDguNTUyMjggMTcgOEMxNyA3LjQ0NzcyIDE2LjU1MjMgNyAxNiA3TDE2IDlaTTAuMjkyODkzIDcuMjkyODlDLTAuMDk3NjMxIDcuNjgzNDIgLTAuMDk3NjMxMSA4LjMxNjU4IDAuMjkyODkzIDguNzA3MTFMNi42NTY4NSAxNS4wNzExQzcuMDQ3MzggMTUuNDYxNiA3LjY4MDU0IDE1LjQ2MTYgOC4wNzEwNyAxNS4wNzExQzguNDYxNTkgMTQuNjgwNSA4LjQ2MTU5IDE0LjA0NzQgOC4wNzEwNyAxMy42NTY5TDIuNDE0MjEgOEw4LjA3MTA3IDIuMzQzMTVDOC40NjE1OSAxLjk1MjYyIDguNDYxNTkgMS4zMTk0NiA4LjA3MTA3IDAuOTI4OTMxQzcuNjgwNTQgMC41Mzg0MDcgNy4wNDczOCAwLjUzODQwNyA2LjY1Njg1IDAuOTI4OTMxTDAuMjkyODkzIDcuMjkyODlaTTE2IDdMMSA3TDEgOUwxNiA5TDE2IDdaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K");

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgN0MwLjQ0NzcxNSA3IDAgNy40NDc3MiAwIDhDMCA4LjU1MjI4IDAuNDQ3NzE1IDkgMSA5VjdaTTE2LjcwNzEgOC43MDcxMUMxNy4wOTc2IDguMzE2NTggMTcuMDk3NiA3LjY4MzQyIDE2LjcwNzEgNy4yOTI4OUwxMC4zNDMxIDAuOTI4OTMyQzkuOTUyNjIgMC41Mzg0MDggOS4zMTk0NiAwLjUzODQwOCA4LjkyODkzIDAuOTI4OTMyQzguNTM4NDEgMS4zMTk0NiA4LjUzODQxIDEuOTUyNjIgOC45Mjg5MyAyLjM0MzE1TDE0LjU4NTggOEw4LjkyODkzIDEzLjY1NjlDOC41Mzg0MSAxNC4wNDc0IDguNTM4NDEgMTQuNjgwNSA4LjkyODkzIDE1LjA3MTFDOS4zMTk0NiAxNS40NjE2IDkuOTUyNjIgMTUuNDYxNiAxMC4zNDMxIDE1LjA3MTFMMTYuNzA3MSA4LjcwNzExWk0xIDlIMTZWN0gxVjlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K");

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(229)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(234),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40a2ff84",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiByeD0iMzAiIGZpbGw9IiM1NTU1RkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMS40MjM4IDE3LjU2ODFDMzEuNzc1MiAxNy43MzI2IDMxLjk5OTcgMTguMDg1NiAzMS45OTk3IDE4LjQ3MzZWNDIuMTU3OUMzMS45OTk3IDQyLjU0NTkgMzEuNzc1MiA0Mi44OTg5IDMxLjQyMzggNDMuMDYzNEMzMS4wNzI1IDQzLjIyOCAzMC42NTc2IDQzLjE3NDUgMzAuMzU5NSA0Mi45MjYxTDIyLjc0MjkgMzYuNTc4OUgyMC40NzM0QzE4LjQ2NzcgMzYuNTc4OSAxNi44NDE4IDM0Ljk1MyAxNi44NDE4IDMyLjk0NzNWMjcuNjg0MkMxNi44NDE4IDI1LjY3ODUgMTguNDY3NyAyNC4wNTI2IDIwLjQ3MzQgMjQuMDUyNkgyMi43NDI5TDMwLjM1OTUgMTcuNzA1NEMzMC42NTc2IDE3LjQ1NyAzMS4wNzI1IDE3LjQwMzUgMzEuNDIzOCAxNy41NjgxWk0zOC4xODczIDIxLjcxMzlDMzguNTc3OCAyMS4zMjM0IDM5LjIxMSAyMS4zMjM0IDM5LjYwMTUgMjEuNzEzOUM0MS44NTc0IDIzLjk2OTggNDIuNTI2IDI3LjU5MjQgNDIuNTI2IDMwLjMxNThDNDIuNTI2IDMzLjAzOTEgNDEuODU3NCAzNi42NjE3IDM5LjYwMTUgMzguOTE3NkMzOS4yMTEgMzkuMzA4MSAzOC41Nzc4IDM5LjMwODEgMzguMTg3MyAzOC45MTc2QzM3Ljc5NjggMzguNTI3MSAzNy43OTY4IDM3Ljg5MzkgMzguMTg3MyAzNy41MDM0QzM5Ljg3ODggMzUuODExOSA0MC41MjYgMzIuODU1NSA0MC41MjYgMzAuMzE1OEM0MC41MjYgMjcuNzc2IDM5Ljg3ODggMjQuODE5NiAzOC4xODczIDIzLjEyODFDMzcuNzk2OCAyMi43Mzc2IDM3Ljc5NjggMjIuMTA0NCAzOC4xODczIDIxLjcxMzlaTTM0LjI0IDI1LjY2MTJDMzQuNjMwNSAyNS4yNzA3IDM1LjI2MzcgMjUuMjcwNyAzNS42NTQyIDI1LjY2MTNDMzYuNTMyOCAyNi41Mzk5IDM3LjI2MjggMjguMTI3OCAzNy4yNjI4IDMwLjMxNThDMzcuMjYyOCAzMi41MDM3IDM2LjUzMjggMzQuMDkxNiAzNS42NTQyIDM0Ljk3MDJDMzUuMjYzNiAzNS4zNjA3IDM0LjYzMDUgMzUuMzYwNyAzNC4yNCAzNC45NzAyQzMzLjg0OTQgMzQuNTc5NyAzMy44NDk0IDMzLjk0NjUgMzQuMjQgMzMuNTU2QzM0LjY3NzEgMzMuMTE4OSAzNS4yNjI4IDMyLjA3NTIgMzUuMjYyOCAzMC4zMTU4QzM1LjI2MjggMjguNTU2MyAzNC42NzcxIDI3LjUxMjYgMzQuMjM5OSAyNy4wNzU1QzMzLjg0OTQgMjYuNjg0OSAzMy44NDk0IDI2LjA1MTggMzQuMjQgMjUuNjYxMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=");

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAyNCAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE2NV8xMDA5NikiPgo8cGF0aCBkPSJNMTIuNjE1OCAyMy41MTk1TDExLjk0NzkgMjIuOTI0NUwxMS4yODI0IDIzLjUyMjJMMSAzMi43NTc3TDEgMUwyMyAxTDIzIDMyLjc2OTlMMTIuNjE1OCAyMy41MTk1WiIgZmlsbD0iI0ZGNTU3NCIgc3Ryb2tlPSIjRkY1NTc0IiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTE3LjMzMjEgOS4wOTg1MkMxNi44NTkyIDguNjMzODMgMTYuMDk3NCA4LjYzMzgzIDE1LjYyNzggOS4wOTg1MkwxMC4zNDk5IDE0LjMyNzJMOC4zNzI0NiAxMi4zNzJDNy44OTk1NCAxMS45MDczIDcuMTM3NyAxMS45MDczIDYuNjY4MTEgMTIuMzcyQzYuMTk4NTIgMTIuODQgNi4xOTg1MiAxMy41OTM5IDYuNjY4MTEgMTQuMDU4Nkw5LjM4MzI0IDE2Ljc0M0M5LjQxNTcxIDE2Ljc4NSA5LjQ1MTUyIDE2LjgyNjIgOS40OTA2NSAxNi44NjQ5QzkuNzc4NzMgMTcuMTUgMTAuMTc1OSAxNy4yNjEyIDEwLjU0NzIgMTcuMTk4NkMxMC43OTAzIDE3LjE2MDcgMTEuMDI0MyAxNy4wNDk1IDExLjIxMDggMTYuODY0OUMxMS4yNDk5IDE2LjgyNjIgMTEuMjg1OCAxNi43ODUgMTEuMzE4MiAxNi43NDIyTDE3LjMzMjEgMTAuNzg1MUMxNy44MDE3IDEwLjMxNzEgMTcuODAxNyA5LjU2MzIyIDE3LjMzMjEgOS4wOTg1MloiIGZpbGw9IndoaXRlIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTY1XzEwMDk2Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjM1IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=");

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5MS42NCA1OC4yIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6bm9uZTtzdHJva2U6IzExOTtzdHJva2UtbGluZWNhcDpzcXVhcmU7c3Ryb2tlLWxpbmVqb2luOmJldmVsO3N0cm9rZS13aWR0aDoxMXB4O308L3N0eWxlPjwvZGVmcz48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxsaW5lIGNsYXNzPSJjbHMtMSIgeDE9IjUuNSIgeTE9IjI4Ljk4IiB4Mj0iNzcuODMiIHkyPSIyOC45OCIvPjxsaW5lIGNsYXNzPSJjbHMtMSIgeDE9IjYyLjY1IiB5MT0iNTAuNDIiIHgyPSI4My44NyIgeTI9IjI5LjIiLz48bGluZSBjbGFzcz0iY2xzLTEiIHgxPSI2Mi4xOSIgeTE9IjcuNzgiIHgyPSI4My40MSIgeTI9IjI5Ii8+PC9nPjwvZz48L3N2Zz4=");

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAyNCAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjYxNjYgMjMuNTczNkwxMS45NDc5IDIyLjk3NjVMMTEuMjgxNiAyMy41NzYzTDEgMzIuODMxM0wxIDFMMjMgMUwyMyAzMi44NDM2TDEyLjYxNjYgMjMuNTczNloiIHN0cm9rZT0iI0ZGNTU3NCIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=");

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTcuNDEgOC41OUwxMiAxMy4xN2w0LjU5LTQuNThMMTggMTBsLTYgNi02LTYgMS40MS0xLjQxeiIvPjwvc3ZnPg==");

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(230);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("2144f390", content, true, {});

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.noaudio[data-v-40a2ff84] {\n  min-width: 40px;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/audioBtn.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;CACjB","file":"audioBtn.vue","sourcesContent":["\n.noaudio[data-v-40a2ff84] {\n  min-width: 40px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__audioBtn_scss__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__audioBtn_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__audioBtn_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_audioService__ = __webpack_require__(76);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "audio-btn",
  props: {
    urlId: {
      type: String | Number,
      require: true
    },
    height: {
      type: Number,
      default: 50
    },
    autoplay: {
      type: Boolean,
      deafult: false
    },
    idx: {
      type: Number,
      default: 0
    },
    display: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      audioSrc: "",
      isStop: null,
      showError: false
    };
  },
  created: function created() {
    this.getAudio();
  },

  watch: {
    urlId: function urlId() {
      if (this.idx) return;
      this.isStop = true;
      this.getAudio();
    },
    idx: function idx() {
      this.isStop = true;
      this.getAudio();
    },
    autoplay: function autoplay() {
      if (this.autoplay) this.playAudio();
    }
  },
  methods: {
    getAudio: function getAudio() {
      var _this = this;

      console.log(this.autoplay);
      if (this.urlId) {
        __WEBPACK_IMPORTED_MODULE_3__services_audioService__["a" /* audioService */].playAudio(this.urlId).then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
            var _ref2, sound_file;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return res.json();

                  case 2:
                    _ref2 = _context.sent;
                    sound_file = _ref2.sound_file;

                    _this.audioSrc = sound_file;
                    if (_this.autoplay && _this.audioSrc) {
                      // this.isStop = false;
                      _this.playAudio();
                    }

                  case 6:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      } else {
        this.audioSrc = null;
      }
    },
    playAudio: function playAudio(ev) {
      var _this2 = this;

      if (ev) {
        ev.stopPropagation();
      }
      if (this.$store.getters.isPlaying) {
        setTimeout(function () {}, 1500);
      }
      var audio = new Audio(this.audioSrc);
      document.getElementById('speaker-svg').classList.add("is-playing");
      this.$store.commit("setIsPlaying", true);
      audio.play().then(this.$store.commit("setIsPlaying", false)).catch(function (e) {
        console.log(e);
        _this2.$store.commit("setError", e);
        _this2.$store.commit("setIsPlaying", false);
      });
      document.getElementById('speaker-svg').classList.remove("is-playing");
    }
  },
  updated: function updated() {
    console.log("audio is updated");
  },
  destroyed: function destroyed() {
    this.isStop = true;
  },

  components: {}
});

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(233);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("5ddadbf4", content, true, {});

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".audio-btn{cursor:pointer;position:relative}.audio .audio-btn{width:28px !important;aspect-ratio:1/1}.audio .audio-btn svg{width:100%;height:100%}.speaker-svg{width:60px;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}.is-playing{box-shadow:0 0 10px 6px var(--bubble-bg-selected);border-radius:50%}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/components/Shared/audioBtn.scss","/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/scss/abstracts/_mixins.scss"],"names":[],"mappings":"AAGA,WACE,eACA,iBAAA,CAGF,kBACE,sBACA,gBAAA,CAGF,sBACE,WACA,WAAA,CAGF,aACE,WClBA,kBACA,QACA,SACA,+BAAA,CDmBF,YACE,kDACA,iBAAA,CAAA","file":"audioBtn.scss","sourcesContent":["@import \"../../scss/abstracts/variables\";\n@import \"../../scss/abstracts/mixins\";\n\n.audio-btn {\n  cursor: pointer;\n  position: relative;\n}\n\n.audio .audio-btn {\n  width: 28px !important;\n  aspect-ratio: 1/1;\n}\n\n.audio .audio-btn svg {\n  width: 100%;\n  height: 100%;\n}\n\n.speaker-svg {\n  width: 60px;\n  @include absCenter;\n\n}\n.is-playing {\n  box-shadow: 0 0 10px 6px var(--bubble-bg-selected);\n  border-radius: 50%;\n}","@mixin absCenter {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n//media query\n//1em=16px\n// em and rem in media query always equall fs from browser =16px unless user change it.\n//rem failed work with some of browrswers\n@mixin respon($breakpoint) {\n  @if $breakpoint==no-phone {\n    @media (min-width: 37.5em) {\n      //600px\n      @content;\n    }\n  }\n  @if $breakpoint==phone {\n    @media (max-width: 37.5em) {\n      //600px\n      @content;\n    }\n  }\n  @if $breakpoint==700px {\n    @media (max-width: 43.75em) {\n      //700px\n      @content;\n    }\n  }\n  @if $breakpoint==tab-port {\n    @media (max-width: 56.25em) {\n      //900px\n      @content;\n    }\n  }\n\n  @if $breakpoint==tab-land {\n    @media (max-width: 75em) {\n      //1200px\n      @content;\n    }\n  }\n  @if $breakpoint==big-desktop {\n    //1800px\n    @media (min-width: 112.5em) {\n      @content;\n    }\n  }\n}\n\n@mixin aspect-ratio($width, $height) {\n  position: relative;\n  overflow: hidden;\n  &:before {\n    display: block;\n    content: \"\";\n    width: 100%;\n    padding-top: ($height / $width) * 100%;\n  }\n  > * {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n  }\n\n  > img {\n    object-fit: cover;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.audioSrc) ? _c('button', {
    staticClass: "audio-btn",
    style: ({
      height: _vm.height + 'px',
      width: _vm.height + 'px',
      display: _vm.display ? 'inline-block' : 'none'
    }),
    on: {
      "click": _vm.playAudio
    }
  }, [_c('audio', [_c('source', {
    attrs: {
      "src": _vm.audioSrc,
      "type": "audio/mp3"
    }
  })]), _vm._v(" "), _c('inline-svg', {
    staticClass: "speaker-svg",
    attrs: {
      "id": "speaker-svg",
      "src": __webpack_require__(208).default,
      "aria-label": "My image"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.audioSrc) ? _c('div', {
    staticClass: "noaudio"
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(243)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(248),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(244);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("0c4970e0", content, true, {});

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"progressBar.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progressBar_scss__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progressBar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progressBar_scss__);

//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "progress-bar",
  props: {
    max: {
      type: Number,
      default: 100
    },
    progress: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      style: {}
    };
  },
  created: function created() {
    this.style = { width: this.progress / this.max * 100 + "%" };
  },

  computed: {},
  watch: {
    progress: function progress() {
      this.style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.style, {
        width: this.progress / this.max * 100 + "%"
      });
    }
  },
  methods: {}
});

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(247);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("351700dc", content, true, {});

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".progress-bar{border:#000 1px solid;font-size:40px;height:40px}.progress-bar .container{background-color:#41d988;text-align:center;height:100%;align-items:center}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/components/Shared/progressBar.scss"],"names":[],"mappings":"AACA,cACE,sBACA,eACA,WAAA,CACA,yBACE,yBACA,kBACA,YACA,kBAAA,CAAA","file":"progressBar.scss","sourcesContent":["@import \"../../scss/abstracts/variables\";\n.progress-bar {\n  border: black 1px solid;\n  font-size: 40px;\n  height: 40px;\n  .container {\n    background-color: $green;\n    text-align: center;\n    height: 100%;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 248:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "container flex",
    style: (_vm.style)
  }, [_c('span', {
    staticClass: "mr-20"
  }, [_vm._v(" " + _vm._s(Math.round((_vm.progress / _vm.max) * 100)) + "%")])])])
},staticRenderFns: []}

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arrow-back.svg": 273,
	"./arrow-down-big.svg": 274,
	"./arrow-down.svg": 227,
	"./arrow-left-big.svg": 275,
	"./arrow-left.svg": 205,
	"./arrow-next.svg": 276,
	"./arrow-right-fixed.svg": 277,
	"./arrow-right.svg": 206,
	"./arrow-up.svg": 255
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 254;

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik03LjQxIDE1LjQxTDEyIDEwLjgzbDQuNTkgNC41OEwxOCAxNGwtNi02LTYgNnoiLz48L3N2Zz4=");

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCAxNiAyNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIgMjQuNjg5NkwxMy42NzA2IDE0LjIxN0MxNC4xMTM0IDEzLjgxOTYgMTQuMTEzNCAxMy4xMjU4IDEzLjY3MDYgMTIuNzI4NUwyIDIuMjU1ODYiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==");

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNDYuODggMTU4LjY5Ij48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxyZWN0IHg9IjgwLjI3IiB5PSI1NC41MSIgd2lkdGg9IjE3NC42OSIgaGVpZ2h0PSI0OS41IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNi45NiAxNDEuNzQpIHJvdGF0ZSgtNDUpIi8+PHJlY3QgeD0iLTguMDgiIHk9IjU0LjY4IiB3aWR0aD0iMTc0LjY5IiBoZWlnaHQ9IjQ5LjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDc5LjE1IDE5MS42NCkgcm90YXRlKC0xMzUpIi8+PC9nPjwvZz48L3N2Zz4=");

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAxNSAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjUzNSAxOS40MzUxTDYuMTI5IDExLjAyOTFMMTQuNTM1IDIuNjIzMDVMMTEuOTQxIDAuMDI5MDUyN0wwLjk0MTAwNCAxMS4wMjkxTDExLjk0MSAyMi4wMjkxTDE0LjUzNSAxOS40MzUxWiIgLz4KPC9zdmc+Cg==");

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCAxNiAyNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjUgMjQuNjg5NkwyLjgyOTQxIDE0LjIxN0MyLjM4NjU4IDEzLjgxOTYgMi4zODY1OCAxMy4xMjU4IDIuODI5NDEgMTIuNzI4NUwxNC41IDIuMjU1ODYiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==");

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik04LjU5IDE2LjU5TDEwIDE4bDYtNi02LTYtMS40MSAxLjQxTDEzLjE3IDEyeiIvPjwvc3ZnPg==");

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(294)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(299),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-74ae0dab",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(295);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("2b9d6d51", content, true, {});

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.arrow-svg-chap[data-v-74ae0dab] {\n  margin: auto;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/chapter/chapter-header.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd","file":"chapter-header.vue","sourcesContent":["\n.arrow-svg-chap[data-v-74ae0dab] {\n  margin: auto;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chapter_header_scss__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chapter_header_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__chapter_header_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_progressBar_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_progressBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Shared_progressBar_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "chapter-header",
  props: ["title", "next", "prev"],
  data: function data() {
    return {
      ltr: localStorage.getItem("srcDirection") == "ltr"
    };
  },
  created: function created() {},

  methods: {
    nextChapter: function nextChapter(event) {
      if (this.next) {
        this.$router.push({
          path: "/chapter/" + this.next
        });
      }
    },
    prevChapter: function prevChapter(event) {
      if (this.prev) {
        this.$router.push({
          path: "/chapter/" + this.prev
        });
      }
    }
  },
  components: {
    ProgressBar: __WEBPACK_IMPORTED_MODULE_1__Shared_progressBar_vue___default.a
  }
});

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(298);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("6bf56c3e", content, true, {});

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".chapter-header{display:flex;position:sticky;top:64px;z-index:1000;align-items:center;justify-content:space-between;background-color:var(--header-secondary);padding:12px 16px;color:var(--bg-primary)}.chapter-header h2{text-align:center;font:var(--medium-font)}.chapter-header .progress-bar-container{font:var(--huge-font)}.arrowDiv{display:flex;width:30px;aspect-ratio:1/1;background:var(--bg-primary);box-shadow:0px 4px 4px 0px var(--header-primary);border-radius:50%}.arrowDiv:has(.disabled){opacity:.3;box-shadow:none;visibility:hidden}.arrowDiv:first-of-type .arrow-svg-chap{translate:2px}.arrowDiv:last-of-type .arrow-svg-chap{translate:-2px}.arrowDiv:last-of-type path{stroke:var(--header-secondary)}.arrowDiv .arrow-svg-chap{width:10px}.arrowDiv .arrow-svg-chap.disabled{fill:none}.arrowDiv .arrow-svg-chap.disabled path{stroke:#5a5a5a}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/chapter/src/components/chapter/chapter-header.scss"],"names":[],"mappings":"AAEA,gBACE,aACA,gBACA,SACA,aACA,mBACA,8BACA,yCACA,kBACA,uBAAA,CAEA,mBACE,kBACA,uBAAA,CAGF,wCACE,qBAAA,CAIJ,UACE,aACA,WACA,iBACA,6BACA,iDACA,iBAAA,CAEA,yBACE,WACA,gBACA,iBAAA,CAIA,wCACE,aAAA,CAIF,uCACE,cAAA,CAGF,4BACE,8BAAA,CAIJ,0BACE,UAAA,CAEA,mCACE,SAAA,CAEA,wCACE,cAAA,CAAA","file":"chapter-header.scss","sourcesContent":["@import \"../../scss//abstracts/variables\";\n\n.chapter-header {\n  display: flex;\n  position: sticky;\n  top: 64px;\n  z-index: 1000;\n  align-items: center;\n  justify-content: space-between;\n  background-color: var(--header-secondary);\n  padding: 12px 16px;\n  color: var(--bg-primary);\n\n  h2 {\n    text-align: center;\n    font: var(--medium-font);\n  }\n\n  .progress-bar-container {\n    font: var(--huge-font);\n  }\n}\n\n.arrowDiv {\n  display: flex;\n  width: 30px;\n  aspect-ratio: 1/1;\n  background: var(--bg-primary);\n  box-shadow: 0px 4px 4px 0px var(--header-primary);\n  border-radius: 50%;\n\n  &:has(.disabled) {\n    opacity: 0.3;\n    box-shadow: none;\n    visibility: hidden;\n  }\n\n  &:first-of-type {\n    .arrow-svg-chap {\n      translate: 2px;\n    }\n  }\n  &:last-of-type {\n    .arrow-svg-chap {\n      translate: -2px;\n    }\n\n    path {\n      stroke: var(--header-secondary);\n    }\n  }\n\n  .arrow-svg-chap {\n    width: 10px;\n\n    &.disabled {\n      fill: none;\n\n      path {\n        stroke: #5a5a5a;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter-header"
  }, [_c('div', {
    staticClass: "arrowDiv shrink-on-active",
    on: {
      "click": _vm.prevChapter
    }
  }, [_c('inline-svg', {
    staticClass: "arrow-svg-chap",
    class: {
      disabled: !_vm.prev
    },
    attrs: {
      "src": __webpack_require__(254)("./arrow-" + (_vm.ltr ? 'next' : 'back') + ".svg").default
    }
  })], 1), _vm._v(" "), _c('h2', [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "arrowDiv shrink-on-active",
    on: {
      "click": _vm.nextChapter
    }
  }, [_c('inline-svg', {
    staticClass: "arrow-svg-chap",
    class: {
      disabled: !_vm.next
    },
    attrs: {
      "src": __webpack_require__(254)("./arrow-" + (_vm.ltr ? 'back' : 'next') + ".svg").default
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(358);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("5a086e3a", content, true, {});

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.textBox[data-v-2443c47a] {\n  /* border-style: dashed; */\n  font-size: 20px;\n  width: 100%;\n}\n.dictionary-title[data-v-2443c47a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 22px;\n  text-align: center;\n  font-weight: 400;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background-color: #e7e8fd;\n  padding: 5px 2px;\n  height: 60px;\n}\n.sendBtn[data-v-2443c47a] {\n  font-size: 18px;\n  background-color: #555fff;\n  padding: 4px;\n  color: white;\n  font-weight: 400;\n}\n\n/* .dic-container {\n  height: calc(100vh - 122px - var(--safe));\n} */\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Dictionary/Dictionary.vue"],"names":[],"mappings":";AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;CACb;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;CACd;AACD;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,iBAAiB;CAClB;;AAED;;IAEI","file":"Dictionary.vue","sourcesContent":["\n.textBox[data-v-2443c47a] {\n  /* border-style: dashed; */\n  font-size: 20px;\n  width: 100%;\n}\n.dictionary-title[data-v-2443c47a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 22px;\n  text-align: center;\n  font-weight: 400;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background-color: #e7e8fd;\n  padding: 5px 2px;\n  height: 60px;\n}\n.sendBtn[data-v-2443c47a] {\n  font-size: 18px;\n  background-color: #555fff;\n  padding: 4px;\n  color: white;\n  font-weight: 400;\n}\n\n/* .dic-container {\n  height: calc(100vh - 122px - var(--safe));\n} */\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dictionary_scss__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dictionary_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__dictionary_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chapter_chapter_header__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chapter_chapter_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__chapter_chapter_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search_vue__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__search_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__box_vue__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__box_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__box_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_userService__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_wordService__ = __webpack_require__(47);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  data: function data() {
    return {
      wordSuggestion: "",
      dialog: false,
      msg: "",
      hebSen: null,
      arabSen: null,
      sentenceId: null,
      sentences: [],
      svg: __webpack_require__(385),
      placeholder: this.$t("dictionary.dictionary.suggest")
    };
  },
  created: function created() {},

  computed: {
    word: function word() {
      return this.$store.getters.currWord;
    },
    language: function language() {
      return this.$store.getters.language;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    getRank: function getRank() {
      if (this.user) {
        return this.user.user_rank || 0;
      } else {
        return 0;
      }
    },
    safeZones: function safeZones() {
      return {
        "--safe": this.$store.getters.safeBottom + this.$store.getters.safeTop + "px"
      };
    },
    savedWords: function savedWords() {
      if (this.user) {
        return this.user.saved_words.map(function (word) {
          return word.external_id;
        });
      } else {
        return [];
      }
    }
  },
  watch: {
    word: function word() {
      console.log("WORD", this.word);
      if (this.word) this.getMatchWords(this.word.Eng);else {
        this.hebSen = null;
        this.arabSen = null;
        this.sentenceId = null;
        this.sentences = [];
      }
    }
  },
  methods: {
    setLanguage: function setLanguage() {
      this.$store.commit({ type: "setLanguage", language: this.language });
      this.$store.commit({ type: "setCurrWord", currWord: null });
    },
    selectedWord: function selectedWord(currWord) {
      this.$store.commit({ type: "setCurrWord", currWord: currWord });
      this.msg = "";
    },
    addWord: function addWord() {
      this.dialog = true;
    },
    sendWordRequest: function sendWordRequest() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.wordSuggestion) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__services_userService__["a" /* userService */].addWordSuggestion(_this.wordSuggestion);

              case 3:
                _this.wordSuggestion = "";
                _this.dialog = false;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    searchWord: function searchWord(currWord) {
      var _this2 = this;

      if (!currWord) {
        this.notFound = true;
        setTimeout(function () {
          _this2.notFound = false;
        }, 1500);
        return;
      }
      this.notFound = false;
      this.$store.commit({ type: "setCurrWord", currWord: currWord });
    },
    saveWord: function saveWord(_ref) {
      var _this3 = this;

      var isSaved = _ref.isSaved,
          word = _ref.word;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this3.user) {
                  _context2.next = 3;
                  break;
                }

                // this.msg = "עליך להתחבר על מנת לשמור מילים";
                _this3.msg = _this3.$t("dictionary.dictionary.msg1");
                return _context2.abrupt("return");

              case 3:
                if (!isSaved) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6__services_userService__["a" /* userService */].saveWord(word.id);

              case 6:
                if (!_context2.sent) {
                  _context2.next = 10;
                  break;
                }

                //   ? (this.msg = `המילה ${word.heb}  נשמרה בהצלחה`)
                _this3.msg = _this3.$t("dictionary.dictionary.msg2") + ("" + word.heb);
                _context2.next = 11;
                break;

              case 10:
                //   : (this.msg = `אירעה שגיאה בשמירת המילה`);
                _this3.msg = _this3.$t("dictionary.dictionary.msg3");

              case 11:
                _context2.next = 20;
                break;

              case 13:
                _context2.next = 15;
                return __WEBPACK_IMPORTED_MODULE_6__services_userService__["a" /* userService */].unsaveWord(word.id);

              case 15:
                if (!_context2.sent) {
                  _context2.next = 19;
                  break;
                }

                //   ? (this.msg = `המילה ${word.heb}  הוסרה בהצלחה`)
                _this3.msg = _this3.$t("dictionary.dictionary.msg4") + ("" + word.heb);
                _context2.next = 20;
                break;

              case 19:
                //   : (this.msg = `אירעה שגיאה במחיקת המילה`);
                _this3.msg = _this3.$t("dictionary.dictionary.msg5");

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    navigate: function navigate(path) {
      this.$router.push("/" + path);
    },
    getMatchWords: function getMatchWords(word) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var sword, response, filtered_results, res_check, resd;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("THE WORD IS", word);
                sword = word;

                if (word.substring(0, 3) == "to ") {
                  if (word.substr(3)) {
                    console.log(word.substr(3));
                    sword = word.substr(3);
                  }
                }
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_7__services_wordService__["a" /* wordService */].getSentences(sword);

              case 5:
                response = _context3.sent;
                filtered_results = response.filter(function (res) {
                  return res.order !== -1 && res.article !== "" && res.words.includes(sword);
                });

                if (filtered_results.length) {
                  _context3.next = 9;
                  break;
                }

                return _context3.abrupt("return");

              case 9:
                console.log("Found it few times:", filtered_results);
                res_check = [];
                resd = [];

                filtered_results.forEach(function (res, idx) {
                  if (!res_check.includes(res.sentence)) {
                    // if (this.sentences.length === 3) {
                    //   return;
                    // }
                    res_check.push(res.sentence);
                    resd.push(res);
                    var articleId = res.article;
                    var sentenceNum = res.sentence;
                    var articles = _this4.$store.getters.articles.filter(function (res) {
                      return res.article == articleId && res.sentence == sentenceNum;
                    }).sort(function (a, b) {
                      return a.order > b.order ? 1 : -1;
                    });
                    _this4.sentenceId = "en_" + sentenceNum + "_full";
                    _this4.arabSen = articles.filter(function (res) {
                      return res.order > 0;
                    }).sort(function (a, b) {
                      return a.order > b.order ? 1 : -1;
                    }).map(function (word) {
                      return word.words;
                    }).join(" ");
                    console.log(_this4.arabSen);
                    _this4.hebSen = articles.filter(function (res) {
                      return res.order === 0;
                    }).map(function (word) {
                      return word.words;
                    }).join(" ");
                    _this4.sentences.push({
                      heb: _this4.hebSen,
                      eng: _this4.arabSen,
                      id: _this4.sentenceId
                    });
                  }
                });

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    }
  },
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_4__search_vue___default.a,
    ChapterHeader: __WEBPACK_IMPORTED_MODULE_3__chapter_chapter_header___default.a,
    Box: __WEBPACK_IMPORTED_MODULE_5__box_vue___default.a
  }
});

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(361);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("8c53a052", content, true, {});

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".dic-body{display:block;height:calc(100vh - 180px)}.dic-container{width:100%;font-size:35px;margin:auto;padding:24px;height:calc(100vh - 240px);overflow:scroll;margin-bottom:30px}.dic-container::-webkit-scrollbar{display:none}.msg{background-color:#ff728c;width:70%;margin:0 auto;text-align:center;border-radius:20px;margin-top:10px;padding:5px;font-size:25px}.dic-footer-fixed{position:fixed;bottom:0;right:0;width:100%;border:1px solid #000;background-color:#fff;z-index:1000}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Dictionary/src/components/Dictionary/dictionary.scss"],"names":[],"mappings":"AAEA,UACE,cACA,0BAAA,CAGF,eACE,WACA,eACA,YACA,aACA,2BACA,gBACA,kBAAA,CAGF,kCACE,YAAA,CAEF,KACE,yBACA,UACA,cACA,kBACA,mBACA,gBACA,YACA,cAAA,CAGF,kBACE,eACA,SACA,QACA,WACA,sBACA,sBACA,YAAA,CAAA","file":"dictionary.scss","sourcesContent":["@import \"../../scss/abstracts/variables\";\n\n.dic-body {\n  display: block;\n  height: calc(100vh - 180px);;\n}\n\n.dic-container {\n  width: 100%;\n  font-size: 35px;\n  margin: auto;\n  padding: 24px;\n  height: calc(100vh - 240px);\n  overflow: scroll;\n  margin-bottom: 30px;\n}\n\n.dic-container::-webkit-scrollbar {\n  display: none;\n}\n.msg {\n  background-color: $red-light;\n  width: 70%;\n  margin: 0 auto;\n  text-align: center;\n  border-radius: 20px;\n  margin-top: 10px;\n  padding: 5px;\n  font-size: 25px;\n}\n\n.dic-footer-fixed {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  border: 1px solid black;\n  background-color: white;\n  z-index: 1000;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(363)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(367),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a7cf1f96",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(364);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("697fe089", content, true, {});

/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\nspan[data-v-a7cf1f96] {\n  /* white-space: pre; */\n  font-size: 18px;\n}\n.search-wrapper[data-v-a7cf1f96] {\n  position: relative;\n.dir-left {\n    left: 4px;\n}\n.dir-right {\n    right: 4px;\n}\n}\n.search-wrapper:has(+ .options) input[data-v-a7cf1f96] {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.search-wrapper:has(input:focus) + .options[data-v-a7cf1f96] {\n  border-top-color: #555fff;\n}\n.search-icon[data-v-a7cf1f96] {\n  position: absolute;\n  top: 16px;\n  z-index: 100;\n}\n.search[data-v-a7cf1f96] {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.input[data-v-a7cf1f96] {\n  margin: 0 auto;\n  width: 100%;\n  font-size: 20px;\n  position: relative;\n  border: 2px solid #bbbbc7;\n  border-radius: 8px;\n  padding: 10px 20px;\n  /* -webkit-box-shadow: 2px 2px 7px rgb(60 101 188 / 50%), -2px -2px 3px #fff;\n  box-shadow: 2px 2px 7px rgb(60 101 188 / 50%), -2px -2px 3px #fff; */\n  z-index: 1;\n  background: white;\n&:focus {\n    border: 2px solid #555fff;\n}\n}\n.options[data-v-a7cf1f96] {\n  width: 100%;\n  list-style: none;\n  overflow-y: auto;\n  position: absolute;\n  top: calc(100% - 2px);\n  border: 2px solid #bbbbc7;\n  border-radius: 0 0 4px 4px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  background: #fff;\n  font-size: 1.5rem;\n  z-index: 99;\n  height: auto;\n  max-height: min(520px, calc(100vh - 280px));\n}\n.opt[data-v-a7cf1f96] {\n  padding: 12px 0;\n  cursor: pointer;\n  line-height: 1;\n  text-align: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n&:not(:last-child) {\n    border-bottom: 1px solid #d5d5de;\n}\n}\n.opt[data-v-a7cf1f96]:hover {\n  background: #d4e1f8;\n}\n.mark[data-v-a7cf1f96] {\n  background-color: yellow;\n}\n.addWordCls[data-v-a7cf1f96] {\n  font-size: 16px;\n  font-weight: 500;\n  border-top: 1px solid #bbbbc7;\n  padding: 20px 0;\n}\n.hebFlex[data-v-a7cf1f96] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  white-space: break-spaces;\n}\n.original-word[data-v-a7cf1f96] {\n  color: #555fff;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Dictionary/search.vue"],"names":[],"mappings":";AACA;EACE,uBAAuB;EACvB,gBAAgB;CACjB;AACD;EACE,mBAAmB;AACrB;IACI,UAAU;CACb;AACD;IACI,WAAW;CACd;CACA;AACD;EACE,6BAA6B;EAC7B,8BAA8B;CAC/B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,aAAa;CACd;AACD;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,0BAA0B;MACtB,uBAAuB;UACnB,+BAA+B;CACxC;AACD;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB;uEACqE;EACrE,WAAW;EACX,kBAAkB;AACpB;IACI,0BAA0B;CAC7B;CACA;AACD;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;UACvB,uBAAuB;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,4CAA4C;CAC7C;AACD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;AAClC;IACI,iCAAiC;CACpC;CACA;AACD;EACE,oBAAoB;CACrB;AACD;EACE,yBAAyB;CAC1B;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;CACjB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,0BAA0B;CAC3B;AACD;EACE,eAAe;CAChB","file":"search.vue","sourcesContent":["\nspan[data-v-a7cf1f96] {\n  /* white-space: pre; */\n  font-size: 18px;\n}\n.search-wrapper[data-v-a7cf1f96] {\n  position: relative;\n.dir-left {\n    left: 4px;\n}\n.dir-right {\n    right: 4px;\n}\n}\n.search-wrapper:has(+ .options) input[data-v-a7cf1f96] {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.search-wrapper:has(input:focus) + .options[data-v-a7cf1f96] {\n  border-top-color: #555fff;\n}\n.search-icon[data-v-a7cf1f96] {\n  position: absolute;\n  top: 16px;\n  z-index: 100;\n}\n.search[data-v-a7cf1f96] {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.input[data-v-a7cf1f96] {\n  margin: 0 auto;\n  width: 100%;\n  font-size: 20px;\n  position: relative;\n  border: 2px solid #bbbbc7;\n  border-radius: 8px;\n  padding: 10px 20px;\n  /* -webkit-box-shadow: 2px 2px 7px rgb(60 101 188 / 50%), -2px -2px 3px #fff;\n  box-shadow: 2px 2px 7px rgb(60 101 188 / 50%), -2px -2px 3px #fff; */\n  z-index: 1;\n  background: white;\n&:focus {\n    border: 2px solid #555fff;\n}\n}\n.options[data-v-a7cf1f96] {\n  width: 100%;\n  list-style: none;\n  overflow-y: auto;\n  position: absolute;\n  top: calc(100% - 2px);\n  border: 2px solid #bbbbc7;\n  border-radius: 0 0 4px 4px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  background: #fff;\n  font-size: 1.5rem;\n  z-index: 99;\n  height: auto;\n  max-height: min(520px, calc(100vh - 280px));\n}\n.opt[data-v-a7cf1f96] {\n  padding: 12px 0;\n  cursor: pointer;\n  line-height: 1;\n  text-align: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n&:not(:last-child) {\n    border-bottom: 1px solid #d5d5de;\n}\n}\n.opt[data-v-a7cf1f96]:hover {\n  background: #d4e1f8;\n}\n.mark[data-v-a7cf1f96] {\n  background-color: yellow;\n}\n.addWordCls[data-v-a7cf1f96] {\n  font-size: 16px;\n  font-weight: 500;\n  border-top: 1px solid #bbbbc7;\n  padding: 20px 0;\n}\n.hebFlex[data-v-a7cf1f96] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  white-space: break-spaces;\n}\n.original-word[data-v-a7cf1f96] {\n  color: #555fff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_util_service__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_audioBtn_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_audioBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Shared_audioBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_wordService__ = __webpack_require__(47);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var opensearchEndpoint = "https://os.dev.app.morielenglish.co.il";
var wordsIndexName = localStorage.getItem('wordsIndex');

/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  data: function data() {
    return {
      matchWords: [],
      value: "",
      isLoading: false,
      ltr: localStorage.getItem("srcDirection") == "ltr"
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.focusSearch();
  },

  methods: {
    focusSearch: function focusSearch() {
      this.$refs.searchbox.focus();
    },
    addWord: function addWord() {
      this.matchWords = [];
      this.$emit("addWord");
    },
    getSplitWord: function getSplitWord(word, value, beforeOrAfter) {
      var idx = word.indexOf(value);
      if (!idx) {
        if (!beforeOrAfter) {
          return word.slice(idx, this.value.length);
        } else if (beforeOrAfter === "after") {
          return word.slice(this.value.length - idx, word.length);
        } else {
          return "";
        }
      } else if (idx > 0) {
        if (beforeOrAfter === "before") {
          return word.slice(0, idx);
        } else if (beforeOrAfter === "after") {
          return word.slice(idx + this.value.length, word.length);
        } else {
          return word.slice(idx, idx + this.value.length);
        }
      }
    },
    selectWord: function selectWord(word) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit("selectedWord", word);
                _context.t0 = _this.$store;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__services_wordService__["a" /* wordService */].getSentences(word.Eng);

              case 4:
                _context.t1 = _context.sent;
                _context.t2 = {
                  type: "setFamily",
                  family: _context.t1
                };

                _context.t0.commit.call(_context.t0, _context.t2);

                _this.matchWords = [];

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    search: function search(e) {
      var value = e.target.value;

      this.value = value;
      this.isLoading = true;
      var debounced = __WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* utilService */].debounce(this.getMatchWords, 750);
      debounced();
    },
    getMatchWords: function getMatchWords() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var query, apiUrl, credentials, authHeader, response, results, matchWords;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$emit('selectedWord', null);
                query = {
                  query: {
                    multi_match: {
                      fields: ["Eng", "heb"],
                      query: _this2.value,
                      fuzziness: "AUTO",
                      operator: "and"
                    }
                  },
                  size: 40000
                };
                apiUrl = opensearchEndpoint + '/' + wordsIndexName + '/_search';
                _context2.prev = 3;
                credentials = Buffer.from('admin:' + "27QFPLfri88PsyMKC3d&cehboiYqAK4r").toString('base64');
                authHeader = 'Basic ' + credentials;
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(apiUrl, query, {
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authHeader
                  },
                  withCredentials: false
                });

              case 8:
                response = _context2.sent;
                results = response.data.hits.hits.map(function (hit) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, hit._source, { objectID: hit._id });
                });
                ;

                matchWords = results.map(function (word) {
                  var before = _this2.getSplitWord(word.heb, _this2.value, 'before');
                  var mark = _this2.getSplitWord(word.heb, _this2.value);
                  var after = _this2.getSplitWord(word.heb, _this2.value, 'after');

                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, word, {
                    before: before,
                    mark: mark,
                    after: after
                  });
                });


                _this2.matchWords = matchWords;
                _this2.isLoading = false;

                _context2.next = 20;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](3);

                console.error('Error retrieving data from OpenSearch:', _context2.t0.response ? _context2.t0.response.data : _context2.t0.message);
                _this2.isLoading = false;

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[3, 16]]);
      }))();
    }
  },
  components: { AudioBtn: __WEBPACK_IMPORTED_MODULE_6__Shared_audioBtn_vue___default.a }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32).Buffer))

/***/ }),

/***/ 366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utilService; });
var utilService = {
    debounce: debounce
};
var timer = void 0;
function debounce(func, time) {
    var _this = this,
        _arguments = arguments;

    return function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
            func.apply(_this, _arguments);
        }, time);
    };
}

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search-wrapper"
  }, [_c('input', {
    ref: "searchbox",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('dictionary.search.placeholder')
    },
    on: {
      "input": _vm.search
    }
  }), _vm._v(" "), _c('inline-svg', {
    staticClass: "search-icon",
    class: _vm.ltr ? 'dir-right' : 'dir-left',
    attrs: {
      "width": "40px",
      "src": __webpack_require__(368).default
    }
  })], 1), _vm._v(" "), (_vm.matchWords.length) ? _c('div', {
    staticClass: "options"
  }, [_vm._l((_vm.matchWords), function(word) {
    return _c('div', {
      key: word.idd,
      staticClass: "opt flex",
      on: {
        "click": function($event) {
          return _vm.selectWord(word)
        }
      }
    }, [(word.heb) ? _c('div', {
      staticClass: "heb hebFlex"
    }, [_c('div', {
      staticClass: "translated-word"
    }, [_c('span', [_vm._v(_vm._s(word.Eng))])]), _vm._v(" "), _c('div', {
      staticClass: "original-word"
    }, [_c('span', [_vm._v(_vm._s(word.heb))])])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "opt flex addWordCls",
    on: {
      "click": _vm.addWord
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("dictionary.search.title")) + "\n      ")])], 2) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMyAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMTdDMTMuNDE4MyAxNyAxNyAxMy40MTgzIDE3IDlDMTcgNC41ODE3MiAxMy40MTgzIDEgOSAxQzQuNTgxNzIgMSAxIDQuNTgxNzIgMSA5QzEgMTMuNDE4MyA0LjU4MTcyIDE3IDkgMTdaIiBzdHJva2U9IiMxMTExOTkiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMTUuMzE3OCAxNC4xNTRMMTQuMjg5OCAxNS4yMDAxQzE0LjAwNTkgMTUuNDg5IDE0LjAwNTkgMTUuOTU3MyAxNC4yODk4IDE2LjI0NjJMMTkuNDI5OSAyMS40NzY4QzE5LjcxMzggMjEuNzY1NiAyMC4xNzQgMjEuNzY1NiAyMC40NTc5IDIxLjQ3NjhMMjEuNDg1OSAyMC40MzA3QzIxLjc2OTggMjAuMTQxOCAyMS43Njk4IDE5LjY3MzQgMjEuNDg1OSAxOS4zODQ1TDE2LjM0NTggMTQuMTU0QzE2LjA2MTkgMTMuODY1MSAxNS42MDE3IDEzLjg2NTEgMTUuMzE3OCAxNC4xNTRaIiBmaWxsPSIjMTExMTk5IiBzdHJva2U9IiMxMTExOTkiLz4KPC9zdmc+Cg==");

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(370)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(382),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-018919e4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(371);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("71306eba", content, true, {});

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.textBox[data-v-018919e4] {\n  border-style: dashed;\n  width: 100%;\n}\n.backIcon[data-v-018919e4] {\n  width: 35px;\n}\n.fillBtn[data-v-018919e4] {\n  fill: #000000;\n}\n.hebSen[data-v-018919e4] {\n  color: #000000;\n  margin-top: 10px;\n  direction: ltr;\n}\n.addAssoBtn[data-v-018919e4] {\n  border-radius: 6px;\n  width: 100%;\n  font-size: 26px;\n  border: 1px solid #111199;\n  color: #111199;\n  background-color: #c4c8ff;\n  margin: 10px 0;\n  padding: 6px;\n  text-align: center;\n}\n.dots[data-v-018919e4] {\n  border: 1px solid blue;\n  border-radius: 36px;\n  width: 10px;\n  height: 10px;\n}\n.dotsDiv[data-v-018919e4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n\n  -webkit-box-pack: center;\n\n      -ms-flex-pack: center;\n\n          justify-content: center;\n  text-align: center;\n  gap: 6px;\n  margin-top: 8px;\n  margin-bottom: 10px;\n}\n.dotHide[data-v-018919e4] {\n  display: none;\n}\n.dotActive[data-v-018919e4] {\n  background-color: #555fff;\n}\n.assoText[data-v-018919e4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 115px;\n}\n.uppercase[data-v-018919e4]:first-letter {\n  text-transform: capitalize;\n}\n.audioDis[data-v-018919e4] {\n  /* background-color: gray; */\n  -webkit-filter: grayscale(100%);\n          filter: grayscale(100%);\n}\n.sens[data-v-018919e4] {\n  margin-bottom: 16px;\n  padding: 0 30px;\n}\n.dicWord[data-v-018919e4] {\n  text-align: center;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Dictionary/box.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,YAAY;CACb;AACD;EACE,YAAY;CACb;AACD;EACE,cAAc;CACf;AACD;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;CAChB;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,mBAAmB;CACpB;AACD;EACE,uBAAuB;EACvB,oBAAoB;EACpB,YAAY;EACZ,aAAa;CACd;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;;EAEd,yBAAyB;;MAErB,sBAAsB;;UAElB,wBAAwB;EAChC,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;CACrB;AACD;EACE,cAAc;CACf;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,cAAc;CACf;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,6BAA6B;EAC7B,gCAAgC;UACxB,wBAAwB;CACjC;AACD;EACE,oBAAoB;EACpB,gBAAgB;CACjB;AACD;EACE,mBAAmB;CACpB","file":"box.vue","sourcesContent":["\n.textBox[data-v-018919e4] {\n  border-style: dashed;\n  width: 100%;\n}\n.backIcon[data-v-018919e4] {\n  width: 35px;\n}\n.fillBtn[data-v-018919e4] {\n  fill: #000000;\n}\n.hebSen[data-v-018919e4] {\n  color: #000000;\n  margin-top: 10px;\n  direction: ltr;\n}\n.addAssoBtn[data-v-018919e4] {\n  border-radius: 6px;\n  width: 100%;\n  font-size: 26px;\n  border: 1px solid #111199;\n  color: #111199;\n  background-color: #c4c8ff;\n  margin: 10px 0;\n  padding: 6px;\n  text-align: center;\n}\n.dots[data-v-018919e4] {\n  border: 1px solid blue;\n  border-radius: 36px;\n  width: 10px;\n  height: 10px;\n}\n.dotsDiv[data-v-018919e4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n\n  -webkit-box-pack: center;\n\n      -ms-flex-pack: center;\n\n          justify-content: center;\n  text-align: center;\n  gap: 6px;\n  margin-top: 8px;\n  margin-bottom: 10px;\n}\n.dotHide[data-v-018919e4] {\n  display: none;\n}\n.dotActive[data-v-018919e4] {\n  background-color: #555fff;\n}\n.assoText[data-v-018919e4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 115px;\n}\n.uppercase[data-v-018919e4]:first-letter {\n  text-transform: capitalize;\n}\n.audioDis[data-v-018919e4] {\n  /* background-color: gray; */\n  -webkit-filter: grayscale(100%);\n          filter: grayscale(100%);\n}\n.sens[data-v-018919e4] {\n  margin-bottom: 16px;\n  padding: 0 30px;\n}\n.dicWord[data-v-018919e4] {\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__box_scss__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__box_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__box_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__choose_vue__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__choose_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__choose_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_data_data_json__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_data_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_data_data_json__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    word: {
      type: Object,
      default: function _default() {}
    },
    language: {
      type: String,
      default: "heb"
    },
    savedWords: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hebSen: {
      type: String,
      default: null
    },
    arabSen: {
      type: String,
      default: null
    },
    sentenceId: {
      type: String,
      default: null
    },
    sentences: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      dialog: false,
      isAsso: false,
      assoNum: 0,
      currentAsso: 0,
      senNum: 0,
      currentSen: 0,
      noSound: false,
      isLoadedAudio: false,
      audioSrc: "",
      senAudioSrc: "",
      senAudioId: null,
      optionsRight: [],
      optionsLeft: [],
      settings: {
        left: "",
        right: ""
      },
      showOptions: {
        right: false,
        left: false
      },
      speakerSvg: __webpack_require__(381).default,
      placeholder: this.$t("dictionary.box.placeholder")
    };
  },
  mounted: function mounted() {
    this.noSound = false;
    this.getAudio();
    this.getSenAudio();
    this.assoNum = this.associations.length;
    this.senNum = this.sentences.length;
  },
  created: function created() {
    this.defineSettings();
  },

  computed: {
    isSaved: function isSaved() {
      return this.savedWords.includes(this.word.id);
    },
    associations: function associations() {
      var asso = [];
      if (this.word.asso1) asso.push(this.word.asso1);
      if (this.word.asso2) asso.push(this.word.asso2);
      if (this.word.asso3) asso.push(this.word.asso3);
      this.assoNum = asso.length;
      if (this.assoNum) this.currentAsso = 1;
      return asso;
    }
  },
  watch: {
    word: function word() {
      this.getAudio();
      this.defineSettings();
      var asso = [];
      if (this.word.asso1) asso.push(this.word.asso1);
      if (this.word.asso2) asso.push(this.word.asso2);
      if (this.word.asso3) asso.push(this.word.asso3);
      this.assoNum = asso.length;
      if (this.assoNum) this.currentAsso = 1;
      console.log(this.assoNum);
    },
    sentenceId: function sentenceId() {
      this.getSenAudio();
    },
    senAudioId: function senAudioId() {
      this.getSenAudio();
    },
    sentences: function sentences() {
      this.senNum = this.sentences.length;
      if (this.senNum > 0) this.currentSen = 1;
    },
    currentSen: function currentSen() {
      this.senAudioId = this.sentences[this.currentSen - 1].id;
    }
  },
  updated: function updated() {
    if (this.word && !this.isAsso) {
      var player = this.$refs.player;
      player.load();
    }
    if (this.sentenceId) {
      var senplayer = this.$refs.senplayer;
      senplayer.load();
    }
  },

  methods: {
    goAsso: function goAsso() {
      if (this.assoNum) this.isAsso = true;
    },
    nextAsso: function nextAsso() {
      if (this.currentAsso < this.assoNum) this.currentAsso = this.currentAsso + 1;
    },
    prevAsso: function prevAsso() {
      if (this.currentAsso && this.currentAsso > 1) this.currentAsso = this.currentAsso - 1;
    },
    nextSen: function nextSen() {
      if (this.currentSen < this.senNum) this.currentSen = this.currentSen + 1;
    },
    prevSen: function prevSen() {
      if (this.currentSen && this.currentSen > 1) this.currentSen = this.currentSen - 1;
    },
    goPlay: function goPlay() {
      this.$router.push({ path: "/game/dicword", query: this.word });
    },
    setOption: function setOption(_ref) {
      var _this = this;

      var option = _ref.option,
          side = _ref.side;

      this.settings[side] = option;
      var family = this.$store.getters.family;
      var currWord = family.find(function (word) {
        return word.right === _this.settings.right && word.left === _this.settings.left;
      });
      if (!currWord) {
        this.settings.right = this.word.right;
        this.settings.left = this.word.left;
      }
      this.$emit("search", currWord);
    },
    toggleOptions: function toggleOptions(_ref2) {
      var side = _ref2.side,
          boolean = _ref2.boolean;

      this.showOptions[side] = boolean;
    },
    defineSettings: function defineSettings() {
      var bodies = JSON.parse(__WEBPACK_IMPORTED_MODULE_4__assets_data_data_json___default.a[this.language].bodies) || [];
      var times = JSON.parse(__WEBPACK_IMPORTED_MODULE_4__assets_data_data_json___default.a[this.language].times) || [];
      var groupNames = JSON.parse(__WEBPACK_IMPORTED_MODULE_4__assets_data_data_json___default.a[this.language].groupNames) || [];
      var belongs = JSON.parse(__WEBPACK_IMPORTED_MODULE_4__assets_data_data_json___default.a[this.language].belongs) || [];
      switch (this.word.type) {
        case "פועל":
          this.optionsLeft = bodies;
          this.optionsRight = times;
          break;
        case "עצם":
          this.optionsRight = groupNames;
          this.optionsLeft = belongs;
          break;
        case "noun":
          this.optionsRight = groupNames;
          this.optionsLeft = belongs;
          break;

        case "מילת תואר":
          this.optionsRight = groupNames;
          this.optionsLeft = [];
          break;
        case "מילת יחס":
          this.optionsLeft = belongs;
          this.optionsRight = [];
          break;
      }
      this.settings.left = this.word.left;
      this.settings.right = this.word.right;
    },
    getAudio: function getAudio() {
      var _this2 = this;

      this.isLoadedAudio = false;
      if (!this.word) return;
      // const { id, lang = 'arb' } = this.word;
      var _word = this.word,
          id = _word.id,
          _word$lang = _word.lang,
          lang = _word$lang === undefined ? "" : _word$lang;

      fetch("https://api.dev.app.morielenglish.co.il" + "/api/sound_file/" + id + "/").then(function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
          var _ref4, sound_file;

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(response.status === 200)) {
                    _context.next = 10;
                    break;
                  }

                  _context.next = 3;
                  return response.json();

                case 3:
                  _ref4 = _context.sent;
                  sound_file = _ref4.sound_file;


                  _this2.audioSrc = sound_file;
                  _this2.noSound = false;
                  _this2.isLoadedAudio = true;
                  _context.next = 11;
                  break;

                case 10:
                  _this2.noSound = true;

                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }()).catch(function (err) {
        console.error(err);
      });
    },
    getSenAudio: function getSenAudio() {
      var _this3 = this;

      if (!this.senAudioId) return;
      // const { id, lang = 'arb' } = this.word;

      fetch("https://api.dev.app.morielenglish.co.il" + "/api/sound_file/" + this.senAudioId + "/").then(function () {
        var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(response) {
          var _ref6, sound_file;

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(response.status === 200)) {
                    _context2.next = 8;
                    break;
                  }

                  _context2.next = 3;
                  return response.json();

                case 3:
                  _ref6 = _context2.sent;
                  sound_file = _ref6.sound_file;


                  _this3.senAudioSrc = sound_file;
                  _context2.next = 9;
                  break;

                case 8:
                  _this3.senAudioSrc = null;

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, _this3);
        }));

        return function (_x2) {
          return _ref5.apply(this, arguments);
        };
      }()
      // this.noSound = false;
      // this.isLoadedAudio = true;
      // } else {
      //   this.noSound = true;
      // }
      ).catch(function (err) {
        console.error(err);
      });
    },
    playButton: function playButton() {
      console.log("Play");
      this.$refs.player.play();
    },
    playSenButton: function playSenButton() {
      console.log("Play");
      this.$refs.senplayer.play();
    },
    saveWord: function saveWord(isSaved) {
      this.$emit("saveWord", { isSaved: isSaved, word: this.word });
    }
  },

  components: {
    Choose: __WEBPACK_IMPORTED_MODULE_3__choose_vue___default.a
  }
});

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(374);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("668a2ee1", content, true, {});

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".box{border-radius:9px;margin:0 auto;margin-top:24px;position:relative;background-color:#fff;height:inherit;border:1px solid #505064;padding:20px 0}.box .cls-2{stroke:none}.box .flex{flex:none}.box p{font-size:20px}.box .mischak-svg{width:20px;stroke:none}.box .top-part{display:flex;justify-content:space-between;align-items:center}.box .top-part-asso{display:flex;justify-content:center;align-items:center;padding:10px}.box .select{width:40%}.box .save,.box .assosyazia,.box .mischak{display:flex;flex-direction:column;justify-content:end;align-items:center;width:33%}.box .assosyazia{fill:#000}.box .icon-wrapper{--wrapper-size: 32px;height:var(--wrapper-size);width:var(--wrapper-size);display:grid;place-items:center}.box .bolt-icon{object-fit:contain;height:100%;width:100%;padding:4px}.box .bolt-icon-dis{object-fit:contain;height:100%;width:100%;padding:4px;fill:#999}.box .box-footer{display:flex;width:100%;margin-top:10px;min-height:60px;justify-content:center}.box .save-svg{cursor:pointer;width:17px;aspect-ratio:1/1}.box .choose-elemnt{max-width:50%;z-index:100}.box .translations{display:flex;flex-direction:column;align-items:center}.box .translate{font-size:36px}.box .heb{color:#555fff;font-size:36px}.box .arbT{color:#000}.box .img-audio{fill:#5a3000;width:30px;align-self:center}.box .audioButton{background-color:#555fff;width:20%;justify-content:center;z-index:101;border-radius:8px;height:60px}.box-headline{font-size:20px;margin:44px 0 10px}.audioButton-full{background-color:#555fff;width:100%;height:60px;margin-top:10px}.arrows{height:58px;width:58px;border:#9096ff solid 1px;fill:#000;position:absolute;background-color:#fff;display:flex;align-items:center;justify-content:center;z-index:99}.right-prev,.left-next{top:50%}.right-prev{right:0;translate:34% -50%}.left-next{left:0;translate:-34% -50%}.sentence{font-size:20px !important;color:#555fff}.arrow-icon{align-self:center}.arrow-icon path{fill:var(--header-primary)}.arrow-icon-dis{align-self:center}.arrow-icon-dis path{fill:var(--color-disabled)}.assoBox{fill:#555fff;font-size:30px;padding:20px}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Dictionary/src/components/Dictionary/box.scss"],"names":[],"mappings":"AAEA,KACE,kBACA,cACA,gBACA,kBACA,sBACA,eACA,yBACA,cAAA,CAEA,YACE,WAAA,CAGF,WACE,SAAA,CAGF,OACE,cAAA,CAGF,kBACE,WACA,WAAA,CAGF,eACE,aACA,8BACA,kBAAA,CAGF,oBACE,aACA,uBACA,mBACA,YAAA,CAGF,aACE,SAAA,CAGF,0CAGE,aACA,sBACA,oBACA,mBACA,SAAA,CAGF,iBACE,SAAA,CAGF,mBACE,qBACA,2BACA,0BACA,aACA,kBAAA,CAGF,gBACE,mBACA,YACA,WACA,WAAA,CAGF,oBACE,mBACA,YACA,WACA,YACA,SAAA,CAGF,iBACE,aACA,WACA,gBACA,gBACA,sBAAA,CAGF,eACE,eACA,WACA,gBAAA,CAGF,oBACE,cACA,WAAA,CAGF,mBACE,aACA,sBACA,kBAAA,CAGF,gBACE,cAAA,CAGF,UACE,cACA,cAAA,CAGF,WACE,UAAA,CAGF,gBACE,aACA,WACA,iBAAA,CAGF,kBACE,yBACA,UACA,uBACA,YACA,kBACA,WAAA,CAIJ,cACE,eACA,kBAAA,CAGF,kBACE,yBACA,WACA,YACA,eAAA,CAGF,QACE,YACA,WACA,yBACA,UACA,kBACA,sBACA,aACA,mBACA,uBACA,UAAA,CAGF,uBAEE,OAAA,CAGF,YACE,QACA,kBAAA,CAGF,WACE,OACA,mBAAA,CAGF,UACE,0BACA,aAAA,CAGF,YACE,iBAAA,CAEA,iBACE,0BAAA,CAIJ,gBACE,iBAAA,CACA,qBACE,0BAAA,CAIJ,SACE,aACA,eACA,YAAA,CAAA","file":"box.scss","sourcesContent":["@import \"../../scss/abstracts/variables\";\n\n.box {\n  border-radius: 9px;\n  margin: 0 auto;\n  margin-top: 24px;\n  position: relative;\n  background-color: white;\n  height: inherit;\n  border: 1px solid #505064;\n  padding: 20px 0;\n\n  .cls-2 {\n    stroke: none;\n  }\n\n  .flex {\n    flex: none;\n  }\n\n  p {\n    font-size: 20px;\n  }\n\n  .mischak-svg {\n    width: 20px;\n    stroke: none;\n  }\n\n  .top-part {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .top-part-asso {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px;\n  }\n\n  .select {\n    width: 40%;\n  }\n\n  .save,\n  .assosyazia,\n  .mischak {\n    display: flex;\n    flex-direction: column;\n    justify-content: end;\n    align-items: center;\n    width: 33%;\n  }\n\n  .assosyazia {\n    fill: black;\n  }\n\n  .icon-wrapper {\n    --wrapper-size: 32px;\n    height: var(--wrapper-size);\n    width: var(--wrapper-size);\n    display: grid;\n    place-items: center;\n  }\n\n  .bolt-icon {\n    object-fit: contain;\n    height: 100%;\n    width: 100%;\n    padding: 4px;\n  }\n\n  .bolt-icon-dis {\n    object-fit: contain;\n    height: 100%;\n    width: 100%;\n    padding: 4px;\n    fill: #999999;\n  }\n\n  .box-footer {\n    display: flex;\n    width: 100%;\n    margin-top: 10px;\n    min-height: 60px;\n    justify-content: center;\n  }\n\n  .save-svg {\n    cursor: pointer;\n    width: 17px;\n    aspect-ratio: 1/1;\n  }\n\n  .choose-elemnt {\n    max-width: 50%;\n    z-index: 100;\n  }\n\n  .translations {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .translate {\n    font-size: 36px;\n  }\n\n  .heb {\n    color: #555fff;\n    font-size: 36px;\n  }\n\n  .arbT {\n    color: #000000;\n  }\n\n  .img-audio {\n    fill: #5a3000;\n    width: 30px;\n    align-self: center;\n  }\n\n  .audioButton {\n    background-color: #555fff;\n    width: 20%;\n    justify-content: center;\n    z-index: 101;\n    border-radius: 8px;\n    height: 60px;\n  }\n}\n\n.box-headline {\n  font-size: 20px;\n  margin: 44px 0 10px;\n}\n\n.audioButton-full {\n  background-color: #555fff;\n  width: 100%;\n  height: 60px;\n  margin-top: 10px;\n}\n\n.arrows {\n  height: 58px;\n  width: 58px;\n  border: #9096ff solid 1px;\n  fill: #000000;\n  position: absolute;\n  background-color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 99;\n}\n\n.right-prev,\n.left-next {\n  top: 50%;\n}\n\n.right-prev {\n  right: 0;\n  translate: 34% -50%;\n}\n\n.left-next {\n  left: 0;\n  translate: -34% -50%;\n}\n\n.sentence {\n  font-size: 20px !important;\n  color: #555fff;\n}\n\n.arrow-icon {\n  align-self: center;\n  \n  path {\n    fill: var(--header-primary);\n  }\n}\n\n.arrow-icon-dis {\n  align-self: center;\n  path {\n    fill: var(--color-disabled);\n  }\n}\n\n.assoBox {\n  fill: #555fff;\n  font-size: 30px;\n  padding: 20px;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(376)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(379),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f0fb124",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(377);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("56c44c17", content, true, {});

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.icon[data-v-4f0fb124] {\n  fill: #333;\n  height: 100%;\n  width: 30px;\n}\n.icon[data-v-4f0fb124]:hover {\n  fill: white;\n}\n.select-container[data-v-4f0fb124] {\n  position: relative;\n  width: 40%;\n  height: 60px;\n}\n.options-container[data-v-4f0fb124] {\n  width: 100%;\n  position: absolute;\n  -webkit-transition: all 0.6s;\n  transition: all 0.6s;\n}\n.select[data-v-4f0fb124] {\n  background-color: #eeeeee;\n  color: black;\n  cursor: pointer;\n  height: 100%;\n  width: 100%;\n  font-size: 20px;;\n  -webkit-box-pack: center;;\n      -ms-flex-pack: center;;\n          justify-content: center;\n}\n.select .img-arrow[data-v-4f0fb124] {\n  fill: #333333;\n}\n.select span[data-v-4f0fb124] {\n  padding: 3px;\n  -ms-flex-item-align: center;\n      align-self: center;\n  font-family: \"rubik\";\n}\n.selected[data-v-4f0fb124] {\n  color: black;\n  background-color: #cccccc !important;\n  cursor: default !important;\n  text-decoration: underline;\n}\n.selected[data-v-4f0fb124]:hover {\n  color: black !important;\n}\n.option[data-v-4f0fb124] {\n  text-align: center;\n  font-family: \"rubik\";\n  cursor: pointer;\n  background-color: #eeeeee;\n  padding: 8px;\n  font-size: 20px;;\n  height: 100%;\n}\n.option[data-v-4f0fb124]:hover {\n  background-color: #555fff;\n  color: white;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Dictionary/choose.vue"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,aAAa;EACb,YAAY;CACb;AACD;EACE,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;CACd;AACD;EACE,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;CACtB;AACD;EACE,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;CACjC;AACD;EACE,cAAc;CACf;AACD;EACE,aAAa;EACb,4BAA4B;MACxB,mBAAmB;EACvB,qBAAqB;CACtB;AACD;EACE,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,2BAA2B;CAC5B;AACD;EACE,wBAAwB;CACzB;AACD;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,aAAa;CACd","file":"choose.vue","sourcesContent":["\n.icon[data-v-4f0fb124] {\n  fill: #333;\n  height: 100%;\n  width: 30px;\n}\n.icon[data-v-4f0fb124]:hover {\n  fill: white;\n}\n.select-container[data-v-4f0fb124] {\n  position: relative;\n  width: 40%;\n  height: 60px;\n}\n.options-container[data-v-4f0fb124] {\n  width: 100%;\n  position: absolute;\n  -webkit-transition: all 0.6s;\n  transition: all 0.6s;\n}\n.select[data-v-4f0fb124] {\n  background-color: #eeeeee;\n  color: black;\n  cursor: pointer;\n  height: 100%;\n  width: 100%;\n  font-size: 20px;;\n  -webkit-box-pack: center;;\n      -ms-flex-pack: center;;\n          justify-content: center;\n}\n.select .img-arrow[data-v-4f0fb124] {\n  fill: #333333;\n}\n.select span[data-v-4f0fb124] {\n  padding: 3px;\n  -ms-flex-item-align: center;\n      align-self: center;\n  font-family: \"rubik\";\n}\n.selected[data-v-4f0fb124] {\n  color: black;\n  background-color: #cccccc !important;\n  cursor: default !important;\n  text-decoration: underline;\n}\n.selected[data-v-4f0fb124]:hover {\n  color: black !important;\n}\n.option[data-v-4f0fb124] {\n  text-align: center;\n  font-family: \"rubik\";\n  cursor: pointer;\n  background-color: #eeeeee;\n  padding: 8px;\n  font-size: 20px;;\n  height: 100%;\n}\n.option[data-v-4f0fb124]:hover {\n  background-color: #555fff;\n  color: white;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["value", "showOptions", "options", "side"],
  created: function created() {},
  data: function data() {
    return {
      svgUp: __webpack_require__(255).default,
      svgDown: __webpack_require__(227).default
    };
  },

  methods: {
    setOption: function setOption(option, side) {
      this.$emit("setOption", { option: option, side: side });
    },
    toggleOptions: function toggleOptions(boolean) {
      this.$emit("toggleOptions", { boolean: boolean, side: this.side });
    }
  },
  components: {}
});

/***/ }),

/***/ 379:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.options.length) ? _c('div', {
    staticClass: "select-container flex col",
    on: {
      "mouseenter": function($event) {
        return _vm.toggleOptions(true)
      }
    }
  }, [_c('div', {
    staticClass: "select flex"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.value))]), _vm._v(" "), _c('img', {
    staticClass: "icon",
    attrs: {
      "src": _vm.svgDown,
      "alt": "down"
    }
  })]), _vm._v(" "), _c('ul', {
    class: {
      'options-container': true,
      none: !_vm.showOptions
    },
    on: {
      "mouseleave": function($event) {
        return _vm.toggleOptions(false)
      }
    }
  }, [_vm._l((_vm.options), function(option) {
    return _c('li', {
      key: option,
      class: {
        option: true,
        selected: option === _vm.value
      },
      on: {
        "click": function($event) {
          return _vm.setOption(option, _vm.side)
        }
      }
    }, [_vm._v("\n      " + _vm._s(option) + "\n    ")])
  }), _vm._v(" "), _c('li', {
    staticClass: "option down",
    on: {
      "click": function($event) {
        return _vm.toggleOptions(false)
      }
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": _vm.svgUp,
      "alt": "up"
    }
  })])], 2)]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 380:
/***/ (function(module, exports) {

module.exports = {"heb":{"bodies":"[\"אני\",\"אנחנו\",\"אתה\",\"את\",\"אתם\",\"הוא\",\"היא\",\"הם\"]","times":"[\"עבר\",\"הווה\",\"שם פועל\",\"ציווי\"]","groupNames":"[\"יחיד\",\"יחידה\",\"רבים\",\"רבות\"]","belongs":"[\"ללא שיוך\",\"שלי\",\"שלך(ז)\",\"שלך(נ)\",\"שלו\",\"שלה\",\"שלנו\",\"שלכם\",\"שלהם\"]"},"en":{"bodies":"[\"I\",\"we\",\"you\",\"him\",\"her\",\"they\"]","times":"[\"past\",\"pressent\",\"שם פועל\",\"ציווי\"]","groupNames":"[\"יחיד\",\"יחידה\",\"רבים\",\"רבות\"]","belongs":"[\"no belong\",\"mine\",\"his\",\"hers\",\"ours\",\"yours\",\"theres\"]"}}

/***/ }),

/***/ 381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,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");

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [(!_vm.isAsso) ? _c('div', [_c('div', {
    staticClass: "top-part"
  }, [(!_vm.isSaved) ? _c('div', {
    staticClass: "save",
    on: {
      "click": function($event) {
        return _vm.saveWord(true)
      }
    }
  }, [_c('div', {
    staticClass: "icon-wrapper"
  }, [_c('inline-svg', {
    staticClass: "save-svg",
    attrs: {
      "src": __webpack_require__(226).default
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("dictionary.box.save")))])]) : _vm._e(), _vm._v(" "), (_vm.isSaved) ? _c('div', {
    staticClass: "save",
    on: {
      "click": function($event) {
        return _vm.saveWord(false)
      }
    }
  }, [_c('div', {
    staticClass: "icon-wrapper"
  }, [_c('inline-svg', {
    staticClass: "save-svg",
    attrs: {
      "src": __webpack_require__(215).default
    }
  })], 1), _vm._v(" "), (_vm.isSaved) ? _c('p', [_vm._v(_vm._s(_vm.$t("dictionary.box.remove")))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "assosyazia",
    on: {
      "click": _vm.goAsso
    }
  }, [_c('div', {
    staticClass: "icon-wrapper"
  }, [_c('inline-svg', {
    class: _vm.assoNum > 0 ? 'bolt-icon' : 'bolt-icon-dis',
    attrs: {
      "src": __webpack_require__(383).default
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("dictionary.box.association")))])]), _vm._v(" "), _c('div', {
    staticClass: "mischak",
    on: {
      "click": _vm.goPlay
    }
  }, [_c('div', {
    staticClass: "icon-wrapper"
  }, [_c('inline-svg', {
    staticClass: "mischak-svg",
    attrs: {
      "src": __webpack_require__(384).default
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("dictionary.box.game")))])])]), _vm._v(" "), _c('div', {
    staticClass: "translations dicWord"
  }, [_c('div', {
    staticClass: "translate arbT"
  }, [_vm._v("\n          " + _vm._s(_vm.word.Eng) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "translate heb"
  }, [_vm._v("\n          " + _vm._s(_vm.word.heb) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [(!_vm.noSound) ? _c('button', {
    staticClass: "audioButton flex",
    attrs: {
      "disabled": !_vm.isLoadedAudio
    },
    on: {
      "click": _vm.playButton
    }
  }, [_c('img', {
    staticClass: "img-audio",
    attrs: {
      "src": _vm.speakerSvg,
      "alt": "audio"
    }
  })]) : _vm._e(), _vm._v(" "), _c('audio', {
    ref: "player"
  }, [_c('source', {
    attrs: {
      "src": _vm.audioSrc,
      "type": "audio/mp3"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.isAsso) ? _c('div', {
    staticClass: "assoBox"
  }, [_c('div', {
    staticClass: "arrows right-prev"
  }, [_c('button', {
    staticClass: "fillBtn",
    on: {
      "click": _vm.prevAsso
    }
  }, [_c('inline-svg', {
    class: _vm.currentAsso > 1 ? 'arrow-icon' : 'arrow-icon-dis',
    attrs: {
      "src": _vm.arrowIconPath.arrowIconPrevious
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "arrows left-next",
    on: {
      "click": _vm.nextAsso
    }
  }, [_c('button', {
    staticClass: "fillBtn"
  }, [_c('inline-svg', {
    class: _vm.currentAsso < _vm.assoNum ? 'arrow-icon' : 'arrow-icon-dis',
    attrs: {
      "src": _vm.arrowIconPath.arrowIcoNext
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "top-part-asso"
  }, [_c('div', {
    staticClass: "backIcon",
    on: {
      "click": function($event) {
        _vm.isAsso = false
      }
    }
  }, [_c('inline-svg', {
    attrs: {
      "src": __webpack_require__(224).default
    }
  }), _vm._v(" "), _c('p')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "assoText"
  }, [_c('div', {
    staticClass: "heb"
  }, [_vm._v("\n          " + _vm._s(_vm.associations[_vm.currentAsso - 1]) + "\n        ")])])]) : _vm._e()]), _vm._v(" "), (_vm.isAsso) ? _c('div', {
    staticClass: "dotsDiv",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "dots",
    class: {
      dotHide: !(_vm.assoNum > 0),
      dotActive: _vm.currentAsso == 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dots",
    class: {
      dotHide: !(_vm.assoNum > 1),
      dotActive: _vm.currentAsso == 2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dots",
    class: {
      dotHide: !(_vm.assoNum > 2),
      dotActive: _vm.currentAsso == 3
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAsso) ? _c('div', {
    staticClass: "addAssoBtn",
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t("dictionary.box.add_association")) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.sentences.length) ? _c('div', {
    staticClass: "box-headline"
  }, [_vm._v("\n    " + _vm._s(_vm.$t("dictionary.box.example")) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.arabSen) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "arrows right-prev"
  }, [_c('button', {
    staticClass: "fillBtn",
    on: {
      "click": _vm.prevSen
    }
  }, [_c('inline-svg', {
    class: _vm.currentSen > 1 ? 'arrow-icon' : 'arrow-icon-dis',
    attrs: {
      "src": __webpack_require__(206).default
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "arrows left-next",
    on: {
      "click": _vm.nextSen
    }
  }, [_c('button', {
    staticClass: "fillBtn"
  }, [_c('inline-svg', {
    class: _vm.currentSen < _vm.senNum ? 'arrow-icon' : 'arrow-icon-dis',
    attrs: {
      "src": __webpack_require__(205).default
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "translations"
  }, [_c('div', {
    staticClass: "sens"
  }, [_c('div', {
    staticClass: "hebSen sentence uppercase"
  }, [_vm._v("\n          " + _vm._s(_vm.sentences[_vm.currentSen - 1].eng) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sentence"
  }, [_vm._v("\n          " + _vm._s(_vm.sentences[_vm.currentSen - 1].heb) + "\n        ")])]), _vm._v(" "), _c('button', {
    staticClass: "audioButton flex",
    class: {
      audioDis: !_vm.senAudioSrc
    },
    attrs: {
      "disabled": !_vm.senAudioSrc
    },
    on: {
      "click": _vm.playSenButton
    }
  }, [_c('img', {
    staticClass: "img-audio",
    class: {
      audioDis: !_vm.senAudioSrc
    },
    attrs: {
      "src": _vm.speakerSvg,
      "alt": "audio"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "senplayer"
  }, [_c('source', {
    attrs: {
      "src": _vm.senAudioSrc,
      "type": "audio/mp3"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("dictionary.box.suggest_association")) + "\n      ")]), _vm._v(" "), _c('v-card-text', [_c('textarea', {
    staticClass: "textBox",
    attrs: {
      "id": "addword",
      "name": "addword",
      "placeholder": _vm.placeholder
    }
  })]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("dictionary.box.send")) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5MC4yOCAxODkuMTYiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojMTE5O308L3N0eWxlPjwvZGVmcz48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoICBkPSJNNjQuNTguODguMjYsMTA3Ljg5YTEuOCwxLjgsMCwwLDAsMS41NSwyLjczSDQwLjE3YTEuOCwxLjgsMCwwLDEsMS43NSwyLjIxbC0xNy4xLDc0LjExYTEuOCwxLjgsMCwwLDAsMy4zMSwxLjMyTDkwLDgzLjYyYTEuOCwxLjgsMCwwLDAtMS41NS0yLjcySDUxLjgzYTEuODEsMS44MSwwLDAsMS0xLjc2LTIuMjJMNjcuODgsMi4yMkExLjgsMS44LDAsMCwwLDY0LjU4Ljg4WiIvPjwvZz48L2c+PC9zdmc+");

/***/ }),

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMi4yOCAyMi43NSI+PGRlZnM+PHN0eWxlPi5naGFsZi1jbHMtMXtmaWxsOiNmZmM1NTg7fS5naGFsZi1jbHMtMiwuZ2hhbGYtY2xzLTN7ZmlsbDpub25lO30uZ2hhbGYtY2xzLTN7c3Ryb2tlOiM3ZTU2MGE7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48ZyBpZD0iR3JvdXBfMjM0IiBkYXRhLW5hbWU9Ikdyb3VwIDIzNCI+PHBhdGggaWQ9IlBhdGhfMjUiIGRhdGEtbmFtZT0iUGF0aCAyNSIgY2xhc3M9ImdoYWxmLWNscy0xIiBkPSJNNCwxNS4xMmMxLjc3LjA3LDE0LjM0LDAsMTQuMzQsMGwtMS41Nyw2LjYzSDUuNVoiLz48cGF0aCBpZD0iUGF0aF8yNiIgZGF0YS1uYW1lPSJQYXRoIDI2IiBjbGFzcz0iZ2hhbGYtY2xzLTEiIGQ9Ik0yLjgzLDExLjJjMiwuMDYsMTYuNDYsMCwxNi40NiwwTDE3LjQ5LDE3SDQuNThaIi8+PGxpbmUgaWQ9IkxpbmVfMTQiIGRhdGEtbmFtZT0iTGluZSAxNCIgY2xhc3M9ImdoYWxmLWNscy0yIiB4MT0iMy41NCIgeTE9IjExLjIiIHgyPSIxOC43OSIgeTI9IjExLjIiLz48bGluZSBpZD0iTGluZV8xMyIgZGF0YS1uYW1lPSJMaW5lIDEzIiBjbGFzcz0iZ2hhbGYtY2xzLTIiIHgxPSIyLjUyIiB5MT0iNS44MSIgeDI9IjE5Ljc0IiB5Mj0iNS44Ii8+PHBhdGggaWQ9IlBhdGhfMjQiIGRhdGEtbmFtZT0iUGF0aCAyNCIgY2xhc3M9ImdoYWxmLWNscy0zIiBkPSJNMS4xNiwxYzEuMzYuMDUsMTQuMTMsMCwxOC44MiwwaDEuMTVzLTMsMjAuNzEtNSwyMC43MUg2QzQuMTMsMjEuNzUsMS4xNiwxLDEuMTYsMVoiLz48L2c+PC9nPjwvZz48L3N2Zz4=");

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mandala.980cde4.svg";

/***/ }),

/***/ 386:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dic-body"
  }, [_c('h1', {
    staticClass: "dictionary-title"
  }, [_vm._v(_vm._s(_vm.$t("dictionary.dictionary.dict")))]), _vm._v(" "), _c('div', {
    staticClass: "dic-container",
    style: (_vm.safeZones)
  }, [_c('div', [_c('Search', {
    on: {
      "selectedWord": _vm.selectedWord,
      "addWord": _vm.addWord
    }
  }), _vm._v(" "), (_vm.word) ? _c('Box', {
    attrs: {
      "language": _vm.language,
      "word": _vm.word,
      "savedWords": _vm.savedWords,
      "hebSen": _vm.hebSen,
      "arabSen": _vm.arabSen,
      "sentenceId": _vm.sentenceId,
      "sentences": _vm.sentences
    },
    on: {
      "search": _vm.searchWord,
      "saveWord": _vm.saveWord
    }
  }) : _vm._e(), _vm._v(" "), (_vm.msg) ? _c('div', {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.msg))]) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("dictionary.dictionary.title")) + "\n        ")]), _vm._v(" "), _c('v-card-text', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wordSuggestion),
      expression: "wordSuggestion"
    }],
    staticClass: "textBox",
    attrs: {
      "id": "addword",
      "name": "addword",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.wordSuggestion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.wordSuggestion = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "sendBtn",
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": _vm.sendWordRequest
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("dictionary.dictionary.send")) + "\n          ")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// 5.ce03fd3d81a126f24b18.bundle.js